(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[49],{

/***/ 33600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgAnchor = function SvgAnchor(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M368 80c0 38.7-27.5 71-64.1 78.4-.8.5.1 1.1.1 1.6v32h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64v256h32c79.5 0 144-64.5 144-144v-25.4l-36.7 36.7c-6.2 6.3-16.4 6.3-22.6 0-6.3-6.2-6.3-16.4 0-22.6l64-64c6.2-6.3 16.4-6.3 22.6 0l64 64c6.3 6.2 6.3 16.4 0 22.6-6.2 6.3-16.4 6.3-22.6 0L512 310.6V336c0 97.2-78.8 176-176 176h-96c-97.2 0-176.9-78.8-176.9-176v-25.4l-35.79 36.7c-6.24 6.3-16.37 6.3-22.624 0-6.248-6.2-6.248-16.4 0-22.6l64.004-64c6.24-6.3 16.37-6.3 22.62 0l63.99 64c6.3 6.2 6.3 16.4 0 22.6-6.2 6.3-16.4 6.3-22.6 0l-37.6-36.7V336c0 79.5 65.4 144 144 144H272V224h-64.9c-7.9 0-16-7.2-16-16s8.1-16 16-16H272v-32c0-.5 0-1.1.1-1.6-36.6-7.4-65-39.7-65-78.4 0-44.18 36.7-80 80-80C332.2 0 368 35.82 368 80zm-80 48c26.5 0 48-21.5 48-48 0-26.51-21.5-48-48-48s-48 21.49-48 48c0 26.5 21.5 48 48 48z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgAnchor);

/***/ }),

/***/ 67210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgFrame = function SvgFrame(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M432 128h-48v256h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48H96v48c0 8.8-7.16 16-16 16s-16-7.2-16-16v-48H16c-8.836 0-16-7.2-16-16s7.164-16 16-16h48V128H16c-8.836 0-16-7.2-16-16s7.164-16 16-16h48V48c0-8.84 7.16-16 16-16s16 7.16 16 16v48h256V48c0-8.84 7.2-16 16-16s16 7.16 16 16v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16zM96 384h256V128H96v256z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgFrame);

/***/ }),

/***/ 89357:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner/[slug]",
      function () {
        return __webpack_require__(35502);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ PartnerPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 5 modules
var transition = __webpack_require__(33587);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./src/components/search/index.js + 17 modules
var components_search = __webpack_require__(74675);
// EXTERNAL MODULE: ./src/components/content/faq.js
var content_faq = __webpack_require__(58130);
// EXTERNAL MODULE: ./src/components/content/headline.js + 1 modules
var headline = __webpack_require__(17587);
// EXTERNAL MODULE: ./public/assets/icons/boat.svg
var boat = __webpack_require__(93238);
// EXTERNAL MODULE: ./public/assets/icons/frame.svg
var icons_frame = __webpack_require__(67210);
// EXTERNAL MODULE: ./public/assets/icons/anchor.svg
var icons_anchor = __webpack_require__(33600);
;// CONCATENATED MODULE: ./src/components/partner/stats.js




function PartnerStats(param) {
    var partner = param.partner;
    var stats = [
        {
            name: 'Boote',
            stat: partner.counts.boats,
            icon: boat/* default */.Z
        },
        {
            name: 'Modelle',
            stat: partner.counts.models,
            icon: icons_frame/* default */.Z
        },
        {
            name: 'Destinationen',
            stat: partner.counts.basements,
            icon: icons_anchor/* default */.Z
        }, 
    ];
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
            className: " grid grid-cols-1 overflow-hidden divide-y divide-gray-200 md:grid-cols-3 md:divide-y-0 md:divide-x order-1 sm:order-2",
            children: stats.map(function(item) {
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    className: "px-7 py-3 flex items-center space-between bg-action",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                            className: "font-bold uppercase text-primary",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-5xl mb-1",
                                    children: item.stat
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-primary opacity-60 line-clamp-1 overflow-hidden",
                                    children: item.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                            className: "mt-1 ml-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(item.icon, {
                                className: "h-20 fill-action-200"
                            })
                        })
                    ]
                }, item.name);
            })
        })
    }));
};

// EXTERNAL MODULE: ./src/components/globals/breadcrumbs.js
var breadcrumbs = __webpack_require__(21859);
// EXTERNAL MODULE: ./src/components/content/cruise-slider.js
var cruise_slider = __webpack_require__(15948);
// EXTERNAL MODULE: ./src/components/helper/seo.js
var seo = __webpack_require__(89388);
// EXTERNAL MODULE: ./src/components/helper/image.js + 1 modules
var helper_image = __webpack_require__(1075);
// EXTERNAL MODULE: ./src/styles/services.module.css
var services_module = __webpack_require__(57784);
var services_module_default = /*#__PURE__*/__webpack_require__.n(services_module);
// EXTERNAL MODULE: ./src/components/helper/link.js
var helper_link = __webpack_require__(34892);
;// CONCATENATED MODULE: ./src/components/content/boat-masonry.js





function BoatMasonry(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items;
    var classMap = [
        '',
        '',
        '',
        '',
        'lg:row-span-2 lg:col-span-2',
        'lg:row-span-2 lg:col-span-2', 
    ];
    var a = items.slice(0, 6);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "grid grid-flow-col lg:grid-flow-row grid-rows-1 lg:grid-rows-3 lg:grid-cols-4 lg:gap-2 overflow-y-hidden overflow-x-auto lg:overflow-hidden lg:h-[500px]",
        /*#__PURE__*/ children: a.map(function(item, k) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                className: "".concat(classMap[k], " w-slider-item h-slider-item lg:w-full lg:h-full text-left overflow-hidden "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
                    href: "/yacht/".concat(item.slug),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: "relative font-bold flex flex-col items-center justify-end h-full duration-500 ease-in-out transition-spacing group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: k > 4 - 1 ? 'absolute text-primary z-20 bg-action group-hover:shadow-lg left-0 bottom-0 w-full transition-all px-3 py-4 text-xl duration-500 ease-in-out text-center lg:text-left' : 'absolute text-primary z-20 bg-action group-hover:shadow-lg left-0 top-0 w-full transition-all px-3 py-2 duration-500 ease-in-out text-center lg:text-left',
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "block mb-0 leading-5 text-center ",
                                    children: item.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative ".concat((services_module_default()).imageWrapper),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                    alt: item.name,
                                    title: item.name,
                                    src: (0,helper_image/* default */.Z)(item.photo_url, {
                                        w: 2000
                                    }),
                                    layout: "fill",
                                    objectFit: "cover"
                                })
                            })
                        ]
                    })
                })
            }, k);
        })
    }));
};

// EXTERNAL MODULE: ./src/components/content/hero.js
var hero = __webpack_require__(80384);
;// CONCATENATED MODULE: ./public/assets/icons/couples.svg
var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCouples = function SvgCouples(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 437 328"
  }, props), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "couples_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h437v328H0z"
  })))), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#couples_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "m377.92 243.1-50.18-12.54-3.7-14.89c13.28-13.59 22.45-31.81 25.51-50.62 7.83-2.81 13.74-9.82 14.82-18.48l3.36-26.93c.8-6.36-1.18-12.79-5.39-17.62a22.432 22.432 0 0 0-7.38-5.58l1.11-22.78 4.42-4.45c8.2-8.71 14.99-23.56 1.01-44.9C350.92 8.16 333.13-.02 308.53-.02c-9.81 0-32.78 0-53.92 15.02-4.09 2.92-5.06 8.6-2.15 12.7 2.9 4.1 8.61 5.05 12.67 2.15 14.47-10.28 30.06-11.66 43.41-11.66 18.06 0 30.74 5.41 37.73 16.09 7.97 12.19 4.97 18.19 1.17 22.23l-6.72 6.74a9.113 9.113 0 0 0-2.66 5.99l-1.64 33.71c-.13 2.48.77 4.89 2.46 6.69s4.04 2.84 6.52 2.86c1.71.02 2.77.95 3.24 1.49a4.21 4.21 0 0 1 1.04 3.39l-3.37 26.95c-.26 2.17-2.13 3.81-4.97 3.81-4.76 0-8.69 3.66-9.07 8.4-1.47 18.55-10.6 37.03-24.44 49.44a9.125 9.125 0 0 0-2.75 8.98l6.32 25.31c.82 3.26 3.35 5.83 6.63 6.63l55.48 13.87c23.67 5.92 41.01 25.42 44.59 48.98l-63.06-.04v18.26l72.82-.06c5.02 0 9.1-4.08 9.1-9.11a77.901 77.901 0 0 0-59.06-75.73Zm-109.25 0-50.18-12.54-2.01-8.07c34.36-6.14 52.17-16.53 52.99-17.01 2.55-1.51 4.15-4.24 4.37-7.21s-1.09-5.92-3.43-7.8c-.23-.18-23.4-19.72-23.4-87.09 0-59.68-14.39-89.93-42.75-89.93h-3.03C191.61 4.34 183.61 0 163.88 0c-26.04 0-83.12 26.04-83.12 103.39 0 67.37-23.16 86.91-23.27 86.99a9.071 9.071 0 0 0-3.63 7.74 9.07 9.07 0 0 0 4.39 7.34c.8.49 18.46 10.93 53.04 17.07l-2 8.02-50.18 12.55C24.3 251.81 0 282.97 0 318.89c0 2.42.95 4.76 2.66 6.45A9.153 9.153 0 0 0 9.11 328l309.54-.06c5.03 0 9.1-4.08 9.1-9.11 0-35.88-24.29-67.02-59.08-75.73ZM18.92 309.74c3.59-23.54 20.94-43.02 44.61-48.96l55.48-13.86a9.136 9.136 0 0 0 6.63-6.64l5.73-22.97c.62-2.52.17-5.16-1.29-7.31a9.1 9.1 0 0 0-6.3-3.92c-21.45-2.98-36.84-7.93-46.02-11.57 9.05-13.12 21.21-40.23 21.21-91.11-.02-70.01 52.04-85.17 64.9-85.17 15.71 0 18.82 2.42 27.2 10.8a9.13 9.13 0 0 0 6.44 2.66h6.74c15.6 0 24.54 26.15 24.54 71.7 0 50.84 12.15 77.96 21.19 91.09-9.23 3.65-24.64 8.57-46.01 11.57-2.57.34-4.84 1.79-6.28 3.92-1.46 2.15-1.91 4.79-1.29 7.31l5.73 23.02c.82 3.26 3.35 5.83 6.63 6.63l55.48 13.87c23.67 5.92 41.01 25.42 44.59 48.98l-289.93-.04Z"
  }))));
};

/* harmony default export */ var couples = (SvgCouples);
;// CONCATENATED MODULE: ./public/assets/icons/families.svg
var families_defs, families_g;

function families_extends() { families_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return families_extends.apply(this, arguments); }



var SvgFamilies = function SvgFamilies(props) {
  return /*#__PURE__*/react.createElement("svg", families_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 392.64 454.65"
  }, props), families_defs || (families_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "families_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h392.64v454.65H0z"
  })))), families_g || (families_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#families_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M92.21.93c-24.57 0-44.62 20.06-44.62 44.65s20.05 44.65 44.62 44.65 44.61-20.06 44.61-44.65S116.78.93 92.21.93Zm208.21 0c-24.57 0-44.62 20.06-44.62 44.65s20.05 44.65 44.62 44.65 44.61-20.06 44.61-44.65S324.98.93 300.42.93ZM92.21 12.84c18.14 0 32.72 14.59 32.72 32.74s-14.58 32.74-32.72 32.74-32.72-14.59-32.72-32.74 14.58-32.74 32.72-32.74Zm208.21 0c18.14 0 32.71 14.59 32.71 32.74s-14.58 32.74-32.71 32.74-32.72-14.59-32.72-32.74 14.58-32.74 32.72-32.74ZM62.46 102.13C28.02 102.13 0 130.17 0 164.64v86.32c0 21.09 15.74 38.57 36.09 41.3l11.53 155.59a5.934 5.934 0 0 0 5.93 5.51h77.33c3.11 0 5.7-2.4 5.92-5.51l7.44-100.39c4.29 4.76 10.1 8.17 16.67 9.5l5.67 90.82c.05.76.23 1.47.55 2.16.32.68.76 1.29 1.31 1.8a5.912 5.912 0 0 0 4.07 1.62h53.54a5.912 5.912 0 0 0 4.07-1.62c.55-.52.99-1.12 1.31-1.8.32-.69.51-1.41.55-2.16l5.67-90.82a30.41 30.41 0 0 0 18.96-12.49l5.36 103.25a5.928 5.928 0 0 0 1.85 4c.55.53 1.18.93 1.89 1.21.71.28 1.44.42 2.2.42h64.97c.76 0 1.49-.14 2.2-.42a5.985 5.985 0 0 0 3.2-3.03c.32-.69.5-1.42.54-2.18l5.89-113.42h24.09c1.73 0 3.38-.76 4.51-2.07s1.63-3.05 1.37-4.76l-6.59-44.55c16.85-7.55 26.81-25.28 24.05-44-4.81-32.7-8.39-56.04-10.67-69.33-6.7-39.09-40.81-67.46-81.08-67.46s-73.16 27.43-80.66 65.48c-5.95-3.74-12.95-5.95-20.47-5.95-5.27 0-10.29 1.07-14.88 2.99 0-34.48-28.02-62.52-62.46-62.52H62.46Zm0 11.91h59.48c27.89 0 50.57 22.7 50.57 50.6v7.88c-7.32 7.05-11.9 16.92-11.9 27.84s4.58 20.79 11.9 27.83v5.07a62.813 62.813 0 0 0-29.74 29.95v-92.62c0-.41-.07-.79-.22-1.17s-.37-.7-.65-.98-.61-.51-.99-.66a2.986 2.986 0 0 0-2.3.02 3.004 3.004 0 0 0-1.58 1.63c-.15.37-.21.75-.21 1.15v115.95l-11.48 154.91H95.18v-151.8c0-.4-.07-.79-.22-1.16-.15-.38-.37-.7-.66-.99s-.61-.5-.98-.65-.76-.22-1.16-.22c-.4 0-.78.09-1.14.24-.36.16-.68.38-.96.66-.27.28-.48.6-.63.97-.15.36-.22.75-.21 1.14v151.8H59.05L47.57 286.52V170.57c.01-.41-.06-.79-.21-1.17s-.37-.7-.66-.98c-.29-.29-.61-.51-.98-.66-.38-.15-.76-.22-1.17-.22-.39 0-.77.09-1.14.24a3.004 3.004 0 0 0-1.58 1.63c-.15.37-.21.75-.21 1.15v110.13c-16.4 0-29.74-13.35-29.74-29.77V164.6c0-27.9 22.68-50.6 50.57-50.6Zm237.95 0c34.47 0 63.64 24.21 69.35 57.57 2.26 13.2 5.84 36.43 10.63 69.05 2.09 14.28-6.2 27.69-19.75 32.36l-15.23-102.86a2.96 2.96 0 0 0-1.06-1.9c-.29-.24-.61-.42-.97-.53-.35-.11-.72-.16-1.1-.14-.42.03-.82.14-1.19.33-.38.19-.69.45-.95.78-.27.33-.45.7-.56 1.11-.1.41-.13.82-.06 1.23l16.11 108.86v.04l3.23 21.79 3.07 20.67H261.74v-32.74c0-13.99-4.68-26.88-12.47-37.31l12.04-81.32c.24-1.63-.88-3.13-2.51-3.37-1.57-.24-3.13.89-3.37 2.51l-11.27 76.13a62.614 62.614 0 0 0-22.08-14.77c9.59-7.05 15.88-18.39 15.88-31.16 0-8.7-2.94-16.72-7.82-23.2.3-1.79.66-4.06.92-5.57 5.72-33.35 34.89-57.56 69.36-57.56Zm-101.13 59.53c14.85 0 26.77 11.92 26.77 26.79s-11.91 26.79-26.77 26.79-26.77-11.92-26.77-26.79 11.92-26.79 26.77-26.79Zm0 65.48c27.99 0 50.56 22.58 50.56 50.6v38.7c0 9.93-7.92 17.86-17.84 17.86V283.7a2.964 2.964 0 0 0-.88-2.15c-.29-.29-.61-.5-.98-.65s-.76-.22-1.16-.22c-.4 0-.78.09-1.14.24-.36.16-.68.38-.96.66-.27.28-.48.6-.63.97-.14.36-.21.75-.21 1.14v68.28l-5.59 89.48h-42.36l-5.59-89.48v-68.28c0-.4-.07-.79-.22-1.16s-.37-.7-.65-.99c-.29-.28-.61-.5-.99-.65a2.986 2.986 0 0 0-2.3.02c-.36.16-.68.38-.95.66-.28.28-.48.6-.63.97-.15.36-.21.75-.21 1.14v62.51c-9.93 0-17.85-7.93-17.85-17.86v-38.7c0-28.02 22.57-50.6 50.57-50.6ZM268 334.3h29.43v107.15h-23.85L268 334.3Zm35.38 0h29.43l-5.58 107.15h-23.85V334.3Z"
  }))));
};

/* harmony default export */ var families = (SvgFamilies);
;// CONCATENATED MODULE: ./public/assets/icons/groups.svg
var groups_defs, groups_g, _path, _g2, _path2, _g3;

function groups_extends() { groups_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return groups_extends.apply(this, arguments); }



var SvgGroups = function SvgGroups(props) {
  return /*#__PURE__*/react.createElement("svg", groups_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 426 312"
  }, props), groups_defs || (groups_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "groups_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M153.2 0h120v93.2h-120z"
  })), /*#__PURE__*/react.createElement("clipPath", {
    id: "groups_svg__b"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h153.2v193.2H0z"
  })), /*#__PURE__*/react.createElement("clipPath", {
    id: "groups_svg__c"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M135.86 118.54h154.67V312H135.86z"
  })))), groups_g || (groups_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#groups_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M160.46 92.27c7.32-7.63 17.63-12.61 29.27-12.61h46.55c11.64 0 21.95 4.98 29.27 12.61 1.99-4.31 4.32-8.3 6.98-11.95-7.98-7.3-18.63-12.61-29.93-13.61 6.65-6.97 10.65-16.59 10.65-26.89 0-21.91-17.96-39.83-39.91-39.83s-39.91 17.92-39.91 39.83c0 10.29 3.99 19.92 10.65 26.89a53.136 53.136 0 0 0-29.93 13.61c2.33 3.98 4.66 7.97 6.32 11.95ZM213 13.28c14.63 0 26.6 11.95 26.6 26.55S227.63 66.39 213 66.39s-26.6-11.95-26.6-26.56 11.97-26.55 26.6-26.55Z"
  }))), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M378.6 66.71c6.65-6.97 10.64-16.59 10.64-26.89 0-21.91-17.96-39.83-39.91-39.83s-39.9 17.92-39.9 39.83c0 10.29 3.99 19.92 10.64 26.89-24.94 2.99-44.9 22.91-46.89 48.13 4.99-6.64 11.31-12.28 18.96-16.27 6.98-11.28 19.62-18.92 33.92-18.92h46.55c21.95 0 39.91 17.92 39.91 39.83v59.74h-19.95V159.3c0-3.65-2.99-6.64-6.65-6.64s-6.65 2.98-6.65 6.64v13.28c3.33 2.65 6.65 5.64 9.65 8.96.33.33.67.99 1.33 1.33 1 .99 1.67 1.99 2.33 2.99 1.66 1.99 2.99 4.31 4.32 6.64h15.63c7.32 0 13.3-5.97 13.3-13.28v-59.74c0-27.22-20.62-49.79-47.22-52.78Zm-29.27-53.44c14.63 0 26.6 11.95 26.6 26.55s-11.97 26.56-26.6 26.56-26.6-11.95-26.6-26.56 11.97-26.55 26.6-26.55Z"
  })), _g2 || (_g2 = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#groups_svg__b)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M36.09 182.89c.33-.33.67-.99 1.33-1.33 2.99-3.32 5.98-6.31 9.65-8.96v-13.28c0-3.65-2.99-6.64-6.65-6.64s-6.65 2.98-6.65 6.64v19.92H13.48V119.5c0-21.91 17.96-39.83 39.91-39.83h46.55c14.3 0 26.94 7.64 33.92 18.92 7.65 3.98 13.96 9.3 18.95 16.27-1.99-25.22-21.95-45.14-46.89-48.13 6.65-6.97 10.64-16.59 10.64-26.89C116.57 17.92 98.61 0 76.66 0s-39.9 17.92-39.9 39.83c0 10.29 3.99 19.92 10.64 26.89C20.8 69.7.18 92.27.18 119.49v59.74c0 7.3 5.99 13.28 13.3 13.28h15.63c1.33-2.32 2.99-4.65 4.32-6.64 1-1 1.66-1.99 2.66-2.99ZM76.66 13.28c14.63 0 26.6 11.95 26.6 26.55s-11.97 26.56-26.6 26.56-26.6-11.95-26.6-26.56 11.97-26.55 26.6-26.55Z"
  }))), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M345.35 172.93c6.65-6.97 10.64-16.59 10.64-26.89 0-21.91-17.96-39.83-39.9-39.83s-39.91 17.92-39.91 39.83c0 10.29 3.99 19.92 10.64 26.89-7.32.99-14.3 3.32-20.61 6.97 4.65 2.32 8.97 5.31 12.97 8.63 4.32-1.66 8.97-2.32 13.63-2.32h46.56c21.95 0 39.9 17.93 39.9 39.83v59.74h-19.95v-19.92c0-3.65-2.99-6.64-6.65-6.64s-6.65 2.99-6.65 6.64v19.92h-43.23v13.28h76.48c7.32 0 13.3-5.97 13.3-13.28V225.7c0-27.22-20.61-49.79-47.22-52.78Zm-29.26-53.44c14.63 0 26.6 11.95 26.6 26.55s-11.97 26.56-26.6 26.56-26.6-11.95-26.6-26.56 11.97-26.55 26.6-26.55ZM86.64 185.88h46.55c4.66 0 9.31.99 13.64 2.32 3.99-3.32 8.31-6.31 12.97-8.63-6.32-3.65-12.97-5.97-20.62-6.97 6.65-6.97 10.64-16.6 10.64-26.89 0-21.91-17.95-39.83-39.9-39.83s-39.91 17.93-39.91 39.83c0 10.29 3.99 19.91 10.64 26.89-26.6 3.32-47.22 25.89-47.22 53.1v59.74c0 7.3 5.98 13.28 13.3 13.28h76.49v-13.28H79.99v-19.92c0-3.65-2.99-6.64-6.65-6.64s-6.65 2.98-6.65 6.64v19.92H46.74V225.7c0-21.91 17.96-39.83 39.91-39.83Zm23.28-66.39c14.63 0 26.6 11.95 26.6 26.55s-11.97 26.56-26.6 26.56-26.6-11.95-26.6-26.56 11.97-26.55 26.6-26.55Z"
  })), _g3 || (_g3 = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#groups_svg__c)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M242.27 186.2c6.65-6.97 10.64-16.59 10.64-26.89 0-21.91-17.96-39.83-39.91-39.83s-39.9 17.92-39.9 39.83c0 10.29 3.99 19.92 10.64 26.89-26.6 2.99-47.22 25.56-47.22 52.78v59.74c0 7.3 5.99 13.28 13.3 13.28h126.36c7.32 0 13.3-5.97 13.3-13.28v-59.74c0-27.22-20.62-49.79-47.22-52.78ZM213 132.76c14.63 0 26.6 11.95 26.6 26.55s-11.97 26.56-26.6 26.56-26.6-11.95-26.6-26.56 11.97-26.55 26.6-26.55Zm63.18 165.96h-19.95V278.8c0-3.65-2.99-6.64-6.65-6.64s-6.65 2.98-6.65 6.64v19.92h-59.85V278.8c0-3.65-2.99-6.64-6.65-6.64s-6.65 2.98-6.65 6.64v19.92h-19.95v-59.74c0-21.91 17.96-39.83 39.91-39.83h46.55c21.95 0 39.91 17.92 39.91 39.83v59.74Z"
  }))));
};

/* harmony default export */ var groups = (SvgGroups);
;// CONCATENATED MODULE: ./public/assets/icons/animals.svg
var animals_defs, animals_g;

function animals_extends() { animals_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return animals_extends.apply(this, arguments); }



var SvgAnimals = function SvgAnimals(props) {
  return /*#__PURE__*/react.createElement("svg", animals_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 384.42"
  }, props), animals_defs || (animals_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "animals_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h400v384.38H0z"
  })))), animals_g || (animals_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#animals_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M58.41 255.29c-3.97-.05-7.87-.61-11.69-1.7s-7.44-2.65-10.84-4.69c-15.57-8.97-27.54-25.95-32.85-46.6-4.41-17.07-3.61-34.58 2.16-49.28 6.03-15.32 16.74-25.84 30.21-29.63 10.93-3.08 22.46-1.39 33.33 4.89 15.56 8.97 27.53 25.96 32.83 46.6 4.4 17.09 3.64 34.59-2.15 49.29-6.03 15.32-16.74 25.84-30.21 29.63a39.67 39.67 0 0 1-10.78 1.49ZM46.12 133.98c-2.54 0-5.03.34-7.48 1.03-20.82 5.84-31.56 34.68-23.92 64.28 4.43 17.27 14.59 31.91 27.17 39.14 7.97 4.61 16.31 5.9 24.05 3.73 20.81-5.85 31.56-34.69 23.92-64.29-4.43-17.27-14.59-31.9-27.17-39.13a32.824 32.824 0 0 0-7.97-3.47 32.96 32.96 0 0 0-8.6-1.28Zm294.55 121.31c-3.67 0-7.26-.5-10.79-1.49-13.46-3.79-24.18-14.3-30.21-29.63-5.78-14.7-6.54-32.2-2.15-49.29 5.3-20.64 17.27-37.63 32.83-46.6 10.88-6.27 22.4-7.98 33.33-4.89 13.46 3.78 24.18 14.3 30.21 29.63 5.78 14.7 6.58 32.21 2.16 49.28-5.3 20.65-17.27 37.64-32.82 46.6a44.327 44.327 0 0 1-10.86 4.69 44.898 44.898 0 0 1-11.7 1.7Zm-31.47-77.4c-7.61 29.6 3.13 58.43 23.92 64.29 7.73 2.17 16.05.89 24.05-3.73 12.58-7.25 22.74-21.89 27.17-39.13 7.61-29.59-3.13-58.43-23.92-64.28-7.74-2.18-16.05-.9-24.05 3.72-12.58 7.26-22.74 21.89-27.17 39.13Zm-173.03-28.14c-9.27 0-18.53-2.95-27.19-8.73-16.54-11.04-28.51-30.7-32.83-53.94-3.6-19.26-1.44-38.61 6.07-54.49C90 16.11 102.6 5.26 117.69 2.03c12.28-2.62 24.86.06 36.39 7.76 16.53 11.04 28.49 30.7 32.83 53.94 3.59 19.27 1.44 38.62-6.07 54.49-7.78 16.48-20.38 27.38-35.46 30.57-3.04.65-6.1.97-9.2.96h-.01Zm-9.33-136.61c-2.23 0-4.44.23-6.62.7-24.1 5.15-38.56 37.02-32.21 71.03 3.68 19.77 14.04 37 27.67 46.11 8.77 5.85 18.17 7.92 27.19 6 24.1-5.15 38.55-37.02 32.21-71.03-3.69-19.77-14.04-37.01-27.68-46.11-6.64-4.41-13.64-6.7-20.56-6.7ZM262.9 149.76c-3.1 0-6.17-.32-9.2-.96-15.08-3.19-27.69-14.07-35.47-30.55-7.5-15.88-9.66-35.23-6.07-54.5 4.34-23.24 16.3-42.9 32.84-53.93 11.53-7.7 24.11-10.39 36.39-7.77 15.09 3.19 27.69 14.08 35.47 30.56 7.51 15.88 9.66 35.23 6.07 54.49-4.33 23.24-16.3 42.91-32.83 53.94-8.66 5.77-17.92 8.72-27.19 8.72Zm9.34-136.62c-6.93 0-13.93 2.27-20.57 6.7-13.64 9.1-23.98 26.35-27.67 46.11-6.34 34.01 8.11 65.88 32.21 71.03 9.03 1.92 18.43-.15 27.19-6 13.63-9.11 23.98-26.35 27.67-46.11 6.38-34.01-8.11-65.88-32.2-71.03-2.19-.47-4.4-.7-6.63-.7Zm-.6 371.28c-12.36 0-23.21-1.24-34.7-2.56-11.49-1.33-23.56-2.7-37.4-2.7s-25.81 1.38-37.4 2.7c-11.59 1.32-22.33 2.56-34.7 2.56-33.31 0-60.42-26.67-60.42-59.46 0-3.72.35-7.42 1.06-11.07.7-3.66 1.74-7.22 3.12-10.68 1.38-3.46 3.07-6.76 5.07-9.9 2.01-3.14 4.29-6.06 6.85-8.76l.08-.08c20.2-22.19 34.64-39.93 46.24-54.19 27.74-34.08 39.23-48.2 70.11-48.2s42.36 14.11 70.11 48.2c11.61 14.26 26.05 32 46.25 54.19l.07.08c2.56 2.7 4.84 5.62 6.84 8.76s3.69 6.43 5.07 9.89 2.41 7.01 3.11 10.67c.7 3.66 1.05 7.34 1.05 11.06 0 32.82-27.11 59.49-60.42 59.49Zm-72.09-17.34c14.53 0 26.84 1.41 38.77 2.78 11.16 1.28 21.66 2.49 33.33 2.49 26.66 0 48.36-21.26 48.36-47.39 0-2.94-.28-5.85-.83-8.74-.55-2.89-1.37-5.7-2.45-8.43s-2.41-5.34-3.99-7.83a46.18 46.18 0 0 0-5.38-6.94l-.2-.21c-20.51-22.51-35.08-40.44-46.83-54.85-26.64-32.74-35.61-43.74-60.77-43.74s-34.14 11.03-60.77 43.74c-11.72 14.42-26.31 32.34-46.83 54.85l-.21.22c-2.01 2.14-3.8 4.45-5.38 6.94a46.758 46.758 0 0 0-7.26 25c0 26.13 21.7 47.39 48.36 47.39 11.67 0 22.19-1.21 33.33-2.49 11.92-1.38 24.24-2.79 38.77-2.79Z"
  }))));
};

/* harmony default export */ var animals = (SvgAnimals);
;// CONCATENATED MODULE: ./public/assets/icons/comfort.svg
var comfort_defs, comfort_g, comfort_path;

function comfort_extends() { comfort_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return comfort_extends.apply(this, arguments); }



var SvgComfort = function SvgComfort(props) {
  return /*#__PURE__*/react.createElement("svg", comfort_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400.63 303"
  }, props), comfort_defs || (comfort_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "comfort_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h265.33v303H0z"
  })))), comfort_g || (comfort_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#comfort_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M256.52 241.77c-3.13 4.06-6.88 7.19-10.94 9.69l2.82 36.23c0 .94.31 1.56.31 2.19l-1.88-.94-81.9-43.11c-1.88-.94-3.75-1.56-5.94-1.56-1.88 0-4.06.63-5.94 1.56l-81.9 43.11-1.88.94c0-.63 0-1.25.31-2.19l15.63-91.21c.63-4.06-.63-8.12-3.75-10.93l-65.95-64.66c-.63-.63-.94-1.25-1.56-1.56.63 0 1.25-.31 2.19-.31l91.59-13.43c4.06-.63 7.5-3.13 9.38-6.87l40.94-83.11.94-1.88.94 1.88 40.95 82.78c1.88 3.74 5.31 6.24 9.38 6.87l40.01 5.94c4.38-3.75 9.06-7.19 13.75-10.62l-52.2-7.5-40.64-82.77C167.74 3.43 163.37 0 158.99 0s-8.76 3.43-12.19 10.31L105.85 93.4l-91.59 13.12c-15.32 2.19-18.44 12.81-7.5 23.43l66.27 64.66-15.63 91.21C55.52 296.75 59.59 303 67.09 303c2.81 0 6.25-.94 10-2.81l81.9-43.11 81.9 43.11c3.75 1.88 7.19 2.81 10.01 2.81 7.5 0 11.56-6.25 9.69-17.18l-4.06-44.05Z"
  }))), comfort_path || (comfort_path = /*#__PURE__*/react.createElement("path", {
    d: "M378.11 77.78c.94 0 1.88 0 2.81.31 14.06 2.81 13.44 27.18-3.44 29.68-57.52 8.12-109.71 54.35-130.03 107.46-2.19 5.62-7.51 8.12-12.82 8.12-1.25 0-2.5 0-3.44-.31-5.32-.94-9.69-4.38-11.26-9.68-6.88-25.61-18.13-44.98-38.76-61.54-11.88-9.69-1.56-25.61 10.63-25.61.94 0 1.88 0 2.81.31 2.19.62 4.38 1.56 6.56 3.12 15.01 12.18 26.26 26.24 34.7 42.17 30.32-48.73 83.77-85.59 139.72-93.4.94-.31 1.56-.63 2.51-.63m0-9.37c-1.26 0-2.51 0-3.76.31-53.14 7.5-104.71 39.67-138.16 85.28-7.81-11.87-17.51-22.49-29.39-31.86-3.44-2.5-6.88-4.38-10.63-5-1.56-.31-3.13-.63-4.69-.63-10.63 0-20.32 7.19-24.07 17.18-3.13 9.06-.31 18.74 7.51 24.99 18.44 14.99 29.07 31.86 35.64 56.85 2.19 8.44 9.38 14.68 18.44 16.56 1.88.31 3.75.63 5.63.63 9.69 0 18.13-5.31 21.57-14.06 20.32-52.48 70.65-94.33 122.85-101.52 12.19-1.88 20.94-11.87 21.57-24.36.31-11.87-6.88-21.55-17.51-23.74-1.88-.31-3.44-.63-5-.63Z"
  })));
};

/* harmony default export */ var comfort = (SvgComfort);
;// CONCATENATED MODULE: ./public/assets/icons/inclusive.svg
var inclusive_defs, inclusive_path, inclusive_g, inclusive_path2;

function inclusive_extends() { inclusive_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return inclusive_extends.apply(this, arguments); }



var SvgInclusive = function SvgInclusive(props) {
  return /*#__PURE__*/react.createElement("svg", inclusive_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 374 441.33"
  }, props), inclusive_defs || (inclusive_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "inclusive_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h374v441.33H0z"
  })))), inclusive_path || (inclusive_path = /*#__PURE__*/react.createElement("path", {
    d: "M252.78 234.01c17.22 0 30.99-13.77 30.99-30.97 0-4.13-2.76-6.89-6.89-6.89s-6.89 2.76-6.89 6.89c0 9.64-7.57 17.21-17.22 17.21s-17.22-7.57-17.22-17.21 7.58-17.21 17.22-17.21c4.14 0 6.89-2.76 6.89-6.89s-2.76-6.88-6.89-6.88c-17.22 0-30.99 13.77-30.99 30.97S235.56 234 252.77 234Z"
  })), inclusive_g || (inclusive_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#inclusive_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M25.48 147.28c3.44-1.38 5.51-5.51 4.13-8.95-1.38-3.44-4.82-5.51-8.95-4.13C8.26 138.33 0 150.03 0 163.11c0 16.52 13.78 30.29 30.31 30.29h3.44c-7.58 18.58-11.02 37.86-11.02 57.82 0 47.49 22.73 94.99 61.3 128.03v37.17c0 14.46 14.46 24.78 26.86 24.78h15.15c12.4 0 20.67-10.32 20.67-24.78v-7.57c24.1 5.51 51.66 5.51 75.77 0v7.57c0 13.77 11.02 24.78 24.1 24.78h14.46c13.09 0 24.11-11.7 24.11-24.78v-37.17c26.17-19.27 44.08-44.74 54.41-75.72h12.4c11.02 0 22.04-11.01 22.04-22.71v-60.58c0-12.39-11.71-19.96-22.04-19.96h-12.4c-9.65-27.53-26.17-52.31-48.21-71.59V70.87c0-4.13-2.76-6.89-6.89-6.89-8.27 0-13.08 1.38-19.28 3.44-6.2 2.07-11.71 5.51-16.53 8.95C241.76 33.7 204.56.66 159.79.66c-49.59 0-89.54 40.61-89.54 89.49 0 14.45 3.44 27.53 9.64 39.92-14.46 12.39-26.17 27.54-35.13 43.37-4.14 4.13-8.95 6.19-13.78 6.19-8.95 0-16.53-7.57-16.53-16.52 0-6.88 4.14-13.77 11.02-15.83ZM159.79 14.43c42.02 0 75.77 34.42 75.77 75.72 0 .69-.69.69-.69 1.38-1.38 2.07-1.38 5.51 0 7.57-4.14 37.86-36.51 67.46-75.77 67.46-42.02 0-75.77-34.42-75.77-75.72s34.45-76.41 76.46-76.41Zm-73.7 128.03c16.53 22.72 42.7 37.86 73.01 37.86 47.53 0 86.79-37.86 89.54-84.67 4.82-6.19 11.71-11.02 20.66-14.45 2.76-1.38 4.82-2.07 7.58-2.07v52.32c0 2.06 1.38 4.13 2.76 5.51.69.69.69 1.38 1.38 2.07 20.66 17.9 36.51 41.3 44.77 68.15.69 3.44 4.13 6.89 11.71 6.89h13.78c4.13 0 8.27 2.75 8.27 6.19v60.58c0 4.13-4.82 8.95-8.27 8.95H337.5c-6.89-.69-9.64 3.44-11.02 6.89-9.64 30.97-27.55 55.76-53.03 73.65-2.07 1.38-2.76 3.44-2.76 5.51v40.61c0 6.2-4.82 11.02-10.33 11.02H245.9c-5.51 0-10.33-5.51-10.33-11.02v-16.52c0-2.06-.69-4.13-2.76-5.51-.69-1.38-3.44-2.06-5.51-1.38-13.08 3.44-28.24 5.51-42.7 5.51s-29.61-2.06-42.7-5.51c-2.07-.69-4.13 0-6.2 1.38s-2.76 3.44-2.76 5.51v16.52c0 2.07 0 11.02-6.89 11.02h-14.46c-6.2 0-13.08-6.19-13.08-11.02v-40.61c0-2.07-.69-4.13-2.76-5.51-37.19-30.29-59.23-75.03-59.23-119.08 0-24.09 6.2-48.19 17.91-69.53l1.38-1.38c.69-.69.69-1.38.69-1.38 8.27-13.77 17.91-26.16 29.61-36.48Z"
  }))), inclusive_path2 || (inclusive_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M148.78 123.19c1.38 1.38 3.44 2.06 4.82 2.06s3.44-.69 4.82-2.06l55.1-55.07c2.76-2.75 2.76-6.88 0-9.64s-6.89-2.76-9.64 0l-50.28 50.25-28.93-28.91c-2.76-2.75-6.89-2.75-9.64 0-2.76 2.76-2.76 6.89 0 9.64l33.75 33.73Z"
  })));
};

/* harmony default export */ var inclusive = (SvgInclusive);
;// CONCATENATED MODULE: ./src/components/partner/features.js







function PartnerFeatures(param) {
    var partner = param.partner;
    var stats = [
        {
            name: 'Paare',
            enabled: partner.features.couples,
            icon: couples
        },
        {
            name: 'Familien',
            enabled: partner.features.families,
            icon: families
        },
        {
            name: 'Gruppen',
            enabled: partner.features.groups,
            icon: groups
        },
        {
            name: 'Haustiere',
            enabled: partner.features.animals,
            icon: animals
        },
        {
            name: 'Komfortklasse',
            enabled: partner.features.comfort,
            icon: comfort
        },
        {
            name: 'Inklusivleistungen',
            enabled: partner.features.inclusive,
            icon: inclusive
        }, 
    ];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-3 mt-1 overflow-hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                className: "-ml-4 grid grid-cols-2 divide-gray-200 md:grid-cols-4 md:divide-x gap-y-2",
                children: stats.filter(function(i) {
                    return i.enabled;
                }).map(function(item) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                        className: "py-1 pl-4 flex items-center text-primary-600",
                        title: "Geeignet f\xfcr ".concat(item.name),
                        "data-tip": "Geeignet f\xfcr ".concat(item.name),
                        "data-type": "dark",
                        "data-effect": "solid",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(item.icon, {
                                className: "w-7 mr-3 fill-green-700 flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "font-semibold line-clamp-1",
                                children: item.name
                            })
                        ]
                    }, item.name);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "text-sm mb-1 text-gray-600 uppercase ml-4 mt-2",
                children: [
                    "↳ Specials bei",
                    ' ',
                    partner.name
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./public/assets/icons/legal.svg
var legal_path;

function legal_extends() { legal_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return legal_extends.apply(this, arguments); }



var SvgLegal = function SvgLegal(props) {
  return /*#__PURE__*/react.createElement("svg", legal_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, props), legal_path || (legal_path = /*#__PURE__*/react.createElement("path", {
    d: "M448 368V48c0-26.51-21.5-48-48-48H80C35.82 0 0 35.82 0 80v368c0 35.35 28.66 64 64 64h368c8.844 0 16-7.156 16-16s-7.2-16-16-16h-16v-66.95c18.6-6.65 32-24.25 32-45.05zm-64 112H64c-17.64 0-32-14.36-32-32s14.36-32 32-32h320v64zm16-96H64c-11.71 0-22.55 3.389-32 8.9V80c0-26.51 21.49-48 48-48h320c8.8 0 16 7.16 16 16v320c0 8.8-7.2 16-16 16zM298.5 254.3c10.71-7.951 17.9-18.6 20.41-31.65 9.469-49.48-39.33-62.25-74.95-71.47l-8.359-2.047C195.5 138.5 189.9 130.6 192.5 117.1c3.656-19.06 34.5-23.61 61.53-19.75 7.75 1.109 17.03 3.391 29.16 7.188 8.406 2.641 17.41-2.047 20.06-10.48 2.625-8.438-2.062-17.41-10.5-20.05-13.81-4.328-24.69-6.984-34.22-8.344-52.63-7.484-90.78 10.39-97.47 45.44C156.4 135.9 166.7 151.4 181.5 161.7c-10.73 7.955-17.92 18.61-20.43 31.68-9.344 48.89 39.88 61.97 66.28 69l8.65 2.22c41.5 10.75 54.75 17.2 51.47 34.31-3.656 19.06-34.38 23.66-61.63 19.75-12.74-1.56-25.94-6.16-38.34-10.26l-6.6-2.1c-8.4-2.7-17.4 1.9-20.1 10.4-2.688 8.422 1.969 17.42 10.38 20.11l6.469 2.109c13.69 4.453 29.19 9.5 43.84 11.5 7.938 1.125 15.5 1.656 22.72 1.656 40.59 0 69.06-17.34 74.75-47.09C323.6 280.3 313.9 264.8 298.5 254.3zm-11-37.7c-2.766 14.45-20.55 18.9-31.04 20.3-4.223-1.166-20.84-5.506-20.84-5.506C195.5 220.8 189.9 212.9 192.5 199.4c2.8-14.5 20.7-19 31.2-20.3 1.215.328 12.25 3.105 12.25 3.105C277.5 192.9 290.8 199.5 287.5 216.6z"
  })));
};

/* harmony default export */ var legal = (SvgLegal);
;// CONCATENATED MODULE: ./src/pages/partner/[slug].js


















var PartnerAreaMap = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(269), __webpack_require__.e(105)]).then(__webpack_require__.bind(__webpack_require__, 27105));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27105)
            ];
        }
    },
    ssr: false
});
var __N_SSP = true;
function PartnerPage(param) {
    var team = param.team, search = param.search, filter = param.filter;
    var ref = (0,react.useState)(true), checked = ref[0], setChecked = ref[1];
    var router = (0,next_router.useRouter)();
    var photoUrl = team.basements.length > 0 ? {
        publicUrl: team.basements[0].photo_url ? "".concat(team.basements[0].photo_url, "?w=2000") : null
    } : null;
    ;
    var faq = {
        content: {
            items: team.faq.map(function(i) {
                return {
                    header: i.question,
                    bodytext: i.answer
                };
            })
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {
                title: "Hausboot mieten bei ".concat(team.name, " | Bootsreisen Partner"),
                description: "Mieten Sie ein Hausboot bei unserem Partner ".concat(team.name, ". W\xe4hlen Sie Ihr Traumboot unter ").concat(team.counts.boats, " Booten in ").concat(team.countries.length, " L\xe4ndern.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero/* default */.Z, {
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: "Hausboot mieten bei"
                }),
                pretitle: "Bootsurlaub mit ".concat(team.name, " in ").concat(team.city),
                teaser: team.teaser,
                after: team.name,
                checked: checked,
                photoUrl: photoUrl,
                regionalStatus: team.regional_status,
                setChecked: setChecked,
                switchLabel: "Partnerinformationen",
                switchSearchLabel: "".concat(team.name, "&apos;s Boote")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                show: !checked,
                enter: "transition-all ease-out duration-200",
                enterFrom: "opacity-0",
                enterTo: "opacity-100 ",
                leave: "transition-all ease-in duration-150",
                leaveFrom: "opacity-100 ",
                leaveTo: "opacity-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "-mt-24 md:-mt-30",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_search/* default */.Z, {
                        data: search.data,
                        meta: search.meta,
                        filter: filter,
                        stayOnPage: true,
                        basements: team.basements
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-7xl mx-auto w-full px-6 py-6 lg:py-4 xl:px-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumbs/* default */.Z, {
                        items: [
                            {
                                label: 'Partner',
                                title: 'Partner',
                                link: '/partner'
                            },
                            {
                                label: team.name,
                                title: team.name,
                                link: "/".concat(router.asPath.slice(1))
                            }, 
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerStats, {
                        partner: team
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid md:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "p-4 bg-gray-50 relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(headline/* default */.Z, {
                                        tag: 2,
                                        children: [
                                            "\xdcber unseren Partner",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute right-5 top-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                    src: (0,helper_image/* default */.Z)(team.photo_url),
                                                    height: 40,
                                                    alt: team.name,
                                                    title: team.name,
                                                    width: 120,
                                                    objectFit: "contain"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerFeatures, {
                                        partner: team
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        dangerouslySetInnerHTML: {
                                            __html: team.description
                                        },
                                        className: "prose min-h-[170px]"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-wrap mt-5",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(legal, {
                                                    className: "h-4 mr-3 flex-shrink-0 fill-primary"
                                                }),
                                                team.agb_url && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://connect.5-anker.com".concat(team.agb_url),
                                                    target: "_blank",
                                                    className: "text-sm uppercase text-gray-500",
                                                    rel: "noreferrer",
                                                    children: "Allgemeine Gesch\xe4ftsbedingungen"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-gray-50 h-[300px] md:h-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerAreaMap, {
                                    team: team
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "my-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(headline/* default */.Z, {
                                after: "Angebote",
                                children: [
                                    team.name,
                                    "'s aktuelle"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(cruise_slider/* default */.Z, {
                                searchQueryParams: {
                                    team_id: team.id,
                                    sort: 'sort',
                                    group: 'model',
                                    limit: 9,
                                    duration: 7
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-gray-50",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-7xl mx-auto w-full px-6 py-6 lg:py-10 xl:px-0 grid gap-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(headline/* default */.Z, {
                            after: "Boote",
                            children: "Beliebte"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BoatMasonry, {
                            items: team.featured.boats
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-w-7xl mx-auto w-full px-6 py-6 lg:py-4 xl:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(content_faq/* default */.Z, {
                        item: faq
                    })
                })
            })
        ]
    }));
};


/***/ }),

/***/ 57784:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"services_imageWrapper__iynnD"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [141,399,840,550,541,749,501,419,96,423,68,774,888,179], function() { return __webpack_exec__(89357); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);